import { render, staticRenderFns } from "./RemoveWatermark.vue?vue&type=template&id=4883e27f&scoped=true"
import script from "./RemoveWatermark.vue?vue&type=script&lang=js"
export * from "./RemoveWatermark.vue?vue&type=script&lang=js"
import style0 from "./RemoveWatermark.vue?vue&type=style&index=0&id=4883e27f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4883e27f",
  null
  
)

export default component.exports